import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Permissions } from '../../core/entities/permissions.model'
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    readonly BASE: any = PETICIONES.permissions;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los permissions
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un permissions por su id
   */
  public findById(id: number): Observable<any> {
    let idpermissions: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idpermissions).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un permissions en la base de datos
   */
  public postSetPermission(permissions: any): Observable<any> {
    const json = JSON.stringify(permissions);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postPermissions, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un permissions en la base de datos
   */
  public deleteSetPermission(permissions: any): Observable<any> {
    const json = JSON.stringify(permissions);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.deletePermissions, json, {headers: headers}).pipe(delay(DELAY));
  }

  public deleteAllPermission(id: number): Observable<any> {
    let idpermissions: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.deleteAllPermissions + "/" + idpermissions).pipe(delay(DELAY));
  }

}